import { Button } from 'antd'
import { type ReactNode, useCallback, useRef, useState } from 'react'
import { useCopyToClipboard } from 'usehooks-ts'

export function CopyButton({ value }: { value: string }): ReactNode {
  const [, copy] = useCopyToClipboard()
  const [copyState, setCopyState] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleCopy = useCallback(async (v: string) => {
    await copy(v)
    setCopyState(true)
    if (timeoutRef.current) clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      setCopyState(false)
    }, 2000)
  }, [copy])

  return (
    <Button
      className="mobilePrimarySmallButton"
      onClick={() => handleCopy(value)}
      type="primary"
      disabled={!value}
      style={{ width: '80px' }}
    >
      {!copyState ? 'Copy' : 'Copied!'}
    </Button>
  )
}
